import { IGroupDeleteAction } from './types';
import { AT_GROUP_DELETE } from './constants';
import { IChatGroup } from 'app/rest/effects/chats/group/types';

export const chatGroupDeleteAction = (
    group: IChatGroup,
): IGroupDeleteAction => ({
    type: AT_GROUP_DELETE,
    group
});
